import Vue from 'vue';
import Router from 'vue-router';
import routerMap from './routerMap';
Vue.use(Router);

const instanceAfter = () => {
    // 是否开启页面离开提醒
    window.$onbeforeunloadFlag = false;
    // 跳出页面
    window.onbeforeunload = function () {
        if (window.$onbeforeunloadFlag) {
            return '请确认是否要离开此页？离开后未保存的内容将不会被记录。';
        }
    };
};

let routerInstance = new Router(routerMap);

export default {
    getRouter() {
        return routerInstance;
    },
    init(store) {
        const router = new Router(routerMap);
        instanceAfter(router, store);
        routerInstance = router;
        return router;
    }
};
